export default __webpack_public_path__ + "static/ruby-crystal-6820c75c3f7432a38268cd5ad9976cad.png";